(function ( $ ) {

    $('.account-content__aside li').click(function(e) {
        let tab = $(this).data('tab');
        $('.account-content__aside li').removeClass('account-content_active');
        $(this).addClass('account-content_active');

        $('.account-content__item').hide();
        $('.account-content__item[data-tab= '+ tab +']').fadeIn();
    });

    $('.account-content__list .user-edit-toggle').click(function(e) {
        $('.account-content__list .user-info').hide();
        $('.account-content__list .user-edit').fadeIn();
    });

    $('.account-content__list .cancel-edit').click(function(e) {
        $('.account-content__list .user-info').fadeIn();
        $('.account-content__list .user-edit').hide();
    });

    $('.user-edit .change-password').click(function(e) {
        e.preventDefault();
        $('html').addClass('open-frame');
        $('.popup-frame').css("display", "flex").hide().fadeIn();
        $('.popup-change-password').fadeIn();
    });

    (function () {
        $('.user-edit').submit(function (e) {
            e.preventDefault();
            let name = $(this).find('[name="name"]').val();
            let phone = $(this).find('[name="phone"]').val();
            let email = $(this).find('[name="email"]').val();
            let self = this;

            $.ajax({
                type: "put",
                url: "/ajax/account/edit",
                cache: false,
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: {
                    name:name,
                    phone:phone ? phone : null,
                    email:email ? email : null,
                },
                beforeSend: function () {
                    $('.user-edit .edit-error-address').html('');
                    $('.user-edit .edit-error-phone').html('');
                    $('.user-edit .edit-error-email').html('');
                    $(self).find(".spinner-for-btn").css('display','inline-block');
                    $(self).find("input[type='submit']").prop('disabled', true);
                },
                error: function (resp) {
                    let errors = JSON.parse(resp.responseText).errors;
                    //console.log(errors);
                    if (errors.hasOwnProperty('name')) {
                        $('.user-edit .edit-error-name').html(errors.name.join(', '));
                    }
                    if (errors.hasOwnProperty('phone')) {
                        $('.user-edit .edit-error-phone').html(errors.phone.join(', '));
                    }
                    if (errors.hasOwnProperty('email')) {
                        $('.user-edit .edit-error-email').html(errors.email.join(', '));
                    }
                },
                success: function (resp) {
                    console.log(resp.user);
                    $('.account-content__list .user-info').fadeIn();
                    $('.account-content__list .user-edit').hide();
                    $('.user-info .user-info-name').html(resp.user.name);
                    $('.user-info .user-info-phone').html(resp.user.phoneNumber);
                    $('.user-info .user-info-email').html(resp.user.email);
                    $(self).find(".spinner-for-btn").hide();
                    $(self).find("input[type='submit']").prop('disabled', false);
                }
            });
        });
    }());

    (function () {
        $('.popup-change-password').submit(function (e) {
            e.preventDefault()
            let password = $(this).find('[name="password"]').val();
            let password_confirmation = $(this).find('[name="password_confirmation"]').val();
            let token = $('meta[name="csrf-token"]').attr('content');

            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find("input[type='submit']").prop('disabled', true);

            axios
                .post(`/ajax/account/password`, {
                    password: password,
                    password_confirmation: password_confirmation,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    $('html').removeClass('open-frame');
                    $('.popup-frame').fadeOut();
                    $('.popup-change-password').fadeOut();
                })
                .catch(error => {
                    let errors = error.response.data.errors;
                    console.log(error.response.data.errors);
                    if (errors.hasOwnProperty('password')) {
                        $('.popup-change-password .edit-error-password').html(errors.password.join(', '));
                    }
                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        });
    }());

}( jQuery ));
